import {
  CCOF_CHANGE_FORM_VALID,
  CCOF_CHANGE_FORM_FIELD,
  CCOF_ADD_SERVICE,
  CCOF_REMOVE_SERVICE,
  CCOF_CHANGE_SERVICE_QUANTITY,
  CCOF_CREATE_MATERIAL,
  CCOF_DELETE_MATERIAL,
  CCOF_RESET_FORM,
  CCOF_UPDATE_FILES,
} from '../mutations/available';
import _ from 'lodash'

export default {
  [CCOF_CHANGE_FORM_VALID] (state, {context, value}) {
    state[context].form.valid = value
  },
  [CCOF_CHANGE_FORM_FIELD] (state, {context, fieldName, value}) {
    state[context].form.errorMessages[fieldName] = null
    state[context].form.data[fieldName] = value
  },
  [CCOF_ADD_SERVICE] (state, {context, serviceId}) {
    state[context].form.data.services.push({
      id: serviceId,
      quantity: 1
    })
  },
  [CCOF_REMOVE_SERVICE] (state, {context, serviceId}) {
    let index = _.findIndex(state[context].form.data.services, function (item) {
      return item.id === serviceId
    })

    if (index < 0) {
      return
    }

    state[context].form.data.services.splice(index, 1)
  },
  [CCOF_CHANGE_SERVICE_QUANTITY] (state, {context, serviceId, quantity}) {
    const  index = _.findIndex(state[context].form.data.services, function (item) {
      return item.id === serviceId
    })

    if (index < 0) {
      return
    }

    state[context].form.data.services[index].quantity = quantity
  },
  [CCOF_CREATE_MATERIAL] (state, {context, material}) {
    state[context].form.data.materials = {
      ...state[context].form.data.materials,
      [material.type]: [
        ...state[context].form.data.materials[material.type] || [],
        {
          code: material.code,
          description: material.description,
          ...(material.type === 'tissues' ? { fragments: material.fragments } : {})
        }
      ]
    }
  },
  [CCOF_DELETE_MATERIAL] (state, {context, type, code}) {
    const index = _.findIndex(state[context].form.data.materials[type], function (item) {
      return item.code === code
    })

    if (index < 0) {
      return
    }

    state[context].form.data.materials[type].splice(index, 1)
  },
  [CCOF_RESET_FORM] (state, context) {
    state[context] = {
      ...state[context],
      form: {
        valid: null,
        errorMessages: [],
        data: {
          patientName: null,
          patientGender: null,
          patientBirthday: null,
          patientAddress: null,
          patientPhone: null,
          patientEmail: null,
          omi_policy_number: null,
          clinicalData: null,
          examination: null,
          receiveMaterialMethod: [],
          diagnosis: null,
          clientSpecialist: null,
          services: [],
          materials: {},
          files: [],
          externalId: null,
          externalLabel: null
        }
      }
    }
  },
  [CCOF_UPDATE_FILES] (state, {context, files}) {
    state[context].form.data.files = files
  }
}